import i18n from '../localizations/i18n';

export default class ErrorMessage {
  static NO_AUDIO = 'NO_AUDIO';
  static NO_MEDIA_DEVICE = 'NO_MEDIA_DEVICE';
  static CAMERA_AND_MIC_PERMISSION_DENIED = 'CAMERA_AND_MIC_PERMISSION_DENIED'
  static SCREEN_SHARE_NOT_SUPPORT = 'SCREEN_SHARE_NOT_SUPPORT'
}
